import { VideoCallSocketContext } from "@contexts/videocall"
import { useContext } from "react"

const CallCountdownTimerVideo = () => {
    const { time, showTimer } = useContext(VideoCallSocketContext)

    return (
        <span>
            {
                time && showTimer &&
                    ` ${time.minutes
                    .toString()
                    .padStart(2, '0')}:${time.seconds.toString().padStart(2, '0')}`
                    
                // add show hours
                // {`${time.hours.toString().padStart(2, '0')}:`}
            }
        </span>
    )
}

export default CallCountdownTimerVideo
